// find an active competition and return the one with the highest id (latest one) //
export const currentCompetition = competitions => {
  if (!competitions) return;
  let comp = competitions.filter(c => c.state.current === "RUNNING")
  if (comp.length > 0) {
    return comp.sort((a, b) => b.id - a.id)[0];
  }
  comp = competitions.filter(c => c.state.current === "COUNTDOWN")
  if (comp.length > 0) {
    return comp.sort((a, b) => b.id - a.id)[0];
  }
  comp = competitions.filter(c => c.state.current === "COOLDOWN")
  if (comp.length > 0) {
    return comp.sort((a, b) => b.id - a.id)[0];
  }
  return []
};